import { isNull } from 'lodash'
import resetOn from './resetOn'
import { isSwapAction, normalizeCollection, swapEdit } from './helpers'
import {
  getProponenteItems,
  getProponenteCash,
  getDestinatarioItems,
  getDestinatarioCash,
  getDestinatarioEsito,
  getProponenteEsito,
} from '../utils'
import {
  GET_SWAP_DETAIL_LOADING,
  GET_SWAP_DETAIL_SUCCESS,
  GET_SWAP_DETAIL_FAILURE,
  GET_SWAP_DETAIL_UNLOAD,
  SWAP_ACTION_ACCEPT_SUCCESS,
  SWAP_ACTION_ACCEPT_FAILURE,
  SWAP_ACTION_ACCEPT_LOADING,
  SWAP_ACTION_REJECT_SUCCESS,
  SWAP_ACTION_REJECT_FAILURE,
  SWAP_ACTION_REJECT_LOADING,
  SWAP_ACTION_CANCEL_SUCCESS,
  SWAP_ACTION_CANCEL_FAILURE,
  SWAP_ACTION_CANCEL_LOADING,
  SWAP_ACTION_FEEDBACK_LOADING,
  SWAP_ACTION_FEEDBACK_SUCCESS,
  SWAP_ACTION_FEEDBACK_FAILURE,
  SWAP_ACTION_ARCHIVE_LOADING,
  SWAP_ACTION_ARCHIVE_SUCCESS,
  SWAP_ACTION_ARCHIVE_FAILURE,
  SWAP_RESET,
  SWAP_REVERSE,
  UPDATE_SWAP_LOADING,
  UPDATE_SWAP_SUCCESS,
  UPDATE_SWAP_FAILURE,
} from '../actions'

const defaultState = {
  loading: false,
  error: null,
  swap: null,
  originalSwap: null,
  updating: false,
  updateError: null,
  performingAction: false, // <--- Performing action on swap state `stato` sush accpet, reject, cancel
  actionError: null,
}

const mapItem = ({ oggetto, posseduto, utente }) => ({
  ...oggetto,
  id: +oggetto.id,
  // Save the world / just for today
  posseduto_da: [{ ...posseduto, user: { id: utente } }],
})

const normalizeSwap = swap => ({
  ...swap,
  proponenteItems: normalizeCollection(getProponenteItems(swap).map(mapItem)),
  destinatarioItems: normalizeCollection(
    getDestinatarioItems(swap).map(mapItem)
  ),
  proponenteMoney: getProponenteCash(swap),
  destinatarioMoney: getDestinatarioCash(swap),
  proponenteEsito: getProponenteEsito(swap),
  destinatarioEsito: getDestinatarioEsito(swap),
})

const reverseSwap = swap => ({
  ...swap,
  proponente: swap.destinatario,
  destinatario: swap.proponente,
  proponenteEsito: swap.destinatarioEsito,
  destinatarioEsito: swap.proponenteEsito,
  proponenteItems: swap.destinatarioItems,
  destinatarioItems: swap.proponenteItems,
  proponenteMoney: swap.destinatarioMoney,
  destinatarioMoney: swap.proponenteMoney,
})

// D.R.Y
const updateUserEsito = (swap, userId, subReducer) => {
  if (userId === swap.proponenteEsito.utente) {
    return {
      proponenteEsito: subReducer(swap.proponenteEsito),
    }
  } else {
    return {
      destinatarioEsito: subReducer(swap.destinatarioEsito),
    }
  }
}

const reducer = (prevState = defaultState, action) => {
  const { type, payload, error } = action

  // Ignore swap action not related to this swap
  if (
    isSwapAction(action) &&
    (isNull(prevState.swap) || prevState.swap.id !== payload.swapId)
  ) {
    return prevState
  }

  switch (type) {
    case GET_SWAP_DETAIL_LOADING:
      return {
        ...prevState,
        loading: true,
        error: null,
      }
    case GET_SWAP_DETAIL_SUCCESS: {
      const swap = normalizeSwap(payload)
      return {
        ...prevState,
        swap,
        originalSwap: { ...swap },
        loading: false,
      }
    }
    case GET_SWAP_DETAIL_FAILURE:
      return {
        ...prevState,
        loading: false,
        error,
      }
    // Difficult: Easy
    case SWAP_RESET:
      return {
        ...prevState,
        swap: { ...prevState.originalSwap },
      }

    case SWAP_ACTION_ACCEPT_LOADING:
    case SWAP_ACTION_REJECT_LOADING:
    case SWAP_ACTION_CANCEL_LOADING:
    case SWAP_ACTION_FEEDBACK_LOADING:
    case SWAP_ACTION_ARCHIVE_LOADING:
      return {
        ...prevState,
        performingAction: true,
        actionError: null,
      }

    case SWAP_ACTION_ACCEPT_FAILURE:
    case SWAP_ACTION_REJECT_FAILURE:
    case SWAP_ACTION_CANCEL_FAILURE:
    case SWAP_ACTION_FEEDBACK_FAILURE:
    case SWAP_ACTION_ARCHIVE_FAILURE:
      return {
        ...prevState,
        performingAction: false,
        actionError: error,
      }

    case SWAP_ACTION_FEEDBACK_SUCCESS:
      return {
        ...prevState,
        performingAction: false,
        swap: {
          ...prevState.swap,
          // Update esito realted to user...
          ...updateUserEsito(prevState.swap, payload.userId, esito => ({
            ...esito,
            motivo: payload.reason,
            feedback: payload.rating,
          })),
        },
      }

    case SWAP_ACTION_ARCHIVE_SUCCESS:
      return {
        ...prevState,
        performingAction: false,
        swap: {
          ...prevState.swap,
          // Update esito realted to user...
          ...updateUserEsito(prevState.swap, payload.userId, esito => ({
            ...esito,
            stato: 'archiviata',
          })),
        },
      }

    case SWAP_ACTION_ACCEPT_SUCCESS:
      return {
        ...prevState,
        performingAction: false,
        swap: {
          ...prevState.swap,
          stato: 'accettata',
        },
      }

    case SWAP_ACTION_REJECT_SUCCESS:
      return {
        ...prevState,
        performingAction: false,
        swap: {
          ...prevState.swap,
          stato: 'rifiutata',
        },
      }

    case SWAP_ACTION_CANCEL_SUCCESS:
      return {
        ...prevState,
        performingAction: false,
        swap: {
          ...prevState.swap,
          stato: 'annullata',
        },
      }

    case UPDATE_SWAP_LOADING:
      return {
        ...prevState,
        updating: true,
        updateError: null,
      }
    case UPDATE_SWAP_SUCCESS: {
      const swap = normalizeSwap(payload)
      return {
        ...prevState,
        updating: false,
        swap,
        originalSwap: { ...swap },
      }
    }

    case UPDATE_SWAP_FAILURE:
      return {
        ...prevState,
        updating: false,
        updateError: error,
      }

    case SWAP_REVERSE:
      return {
        ...prevState,
        swap: reverseSwap(prevState.swap),
      }

    default:
      return prevState
  }
}

export default resetOn(GET_SWAP_DETAIL_UNLOAD, swapEdit('SWAP', reducer))



// WEBPACK FOOTER //
// ./src/reducers/swapDetail.js